import { NotebookIcon, Star, UserIcon } from "lucide-react";
import { Sarah1, StudentsIcon } from "../../../images";
import { renderValidUrl } from "../../../utils/constants";

const ProjectMentor = ({ course }) => {
  const mentor = course?.course_instructor;

  if (!mentor) {
    return (
      <div className="p-[40px] my-5 bg-white rounded">
        <p className="text-gray-500">No mentor information available.</p>
      </div>
    );
  }

  return (
    <div className="p-[40px] my-5 bg-white rounded">
      <h1 className="font-bold text-secondary text-3xl">Meet your Mentor</h1>
      <p className="py-4">
        <img
          src={renderValidUrl(mentor.photo?.url) || Sarah1}
          alt={mentor.name}
          className="rounded-[50%] h-[120px] w-[120px] object-cover"
        />
      </p>
      <p className="font-bold text-xl">{mentor.name}</p>
      <p className="text-[#626262] text-lg pt-1 pb-4">
        {mentor.position[0].qualification || "Mentor"}
      </p>
      <div className="flex flex-col gap-3 text-[12px] mb-4 text-gray-600 md:flex-row md:items-center md:gap-4">
        <div className="flex items-center gap-1">
          <p>
            <Star className="w-6 h-6 text-primaryYellow" />
          </p>
          4.5 Instructor Rating
        </div>
        <div className="flex items-center gap-1">
          <img
            src={StudentsIcon}
            alt="Students"
            className="w-[24px] h-[24px]"
          />{" "}
          40 students
        </div>
        <div className="flex items-center gap-1">
          <p>
            <NotebookIcon className="w-6 h-6 text-primaryYellow" />
          </p>
          8 Courses
        </div>
      </div>
      <p className="text-grey-300">
        {mentor.about || mentor.bio || "No mentor biography available."}
      </p>
    </div>
  );
};

export default ProjectMentor;
